/* eslint-disable jsdoc/check-tag-names -- Introduced in TP-9489. */
/* eslint-disable jsdoc/check-types -- Introduced in TP-9489. */
/* eslint-disable jsdoc/require-param -- Introduced in TP-9489. */
/* eslint-disable jsdoc/require-returns -- Introduced in TP-9489. */
/* eslint-disable jsdoc/tag-lines -- Introduced in TP-9489. */

import Dompurify from 'dompurify';

import { zones } from './zones';
// eslint-disable-next-line import/no-cycle -- Introduced in TP-9489.
import renderFormatSwitcher from './formatSwitcher';

const bannerPath = '/app/static/html/example-ads';

/**
 * Returns iframe DOM element with props
 * key => value object as HTML attributes
 *
 * @param {Object} props
 * @return {Node}
 */
const createIframe = (props) => {
	const iframe = document.createElement('iframe');

	Object.keys(props).forEach((key) => {
		iframe.setAttribute(key, props[key]);
	});

	return iframe;
};

/**
 * Loads banner from url and resolves to its HTML as string
 * @param {*} url banner url
 * @return {Promise}
 */
const loadHtml = (url) =>
	new Promise((resolve, reject) => {
		fetch(`${bannerPath}/${url}`)
			.then((res) => res.text())
			.then((contents) => resolve(contents))
			.catch((e) => reject(e));
	});

/**
 * Returns random element from array
 * @param {Array} banners
 * @return {*}
 */
const randomBanner = (banners) => {
	const min = 0;
	const max = banners.length - 1;
	const rand = Math.floor(Math.random() * (max - min + 1)) + min;

	return banners[rand];
};

const renderBanner = (ad, banner, active = true) => {
	if (banner.type === 'native') {
		/* Native ads are loaded via XHR */
		loadHtml(banner.url)
			// nosemgrep
			.then((html) => (ad.innerHTML = Dompurify.sanitize(html)))
			.catch(() => {
				ad.innerHTML = '';
			});
	} else {
		/* Regular fixed size zones are loaded in iframe */
		const iframe = createIframe({
			width: banner.dimensions[0],
			height: banner.dimensions[1],
			frameborder: 0,
			src: `${bannerPath}/${banner.url}`,
		});

		ad.innerHTML = '';
		ad.appendChild(iframe);
	}

	ad.classList.toggle('ad-inactive', !active);

	if (banner.caption) {
		ad.classList.add('Exp-ad-caption');
	}
};

/**
 * Gets all formats (dimensions) from banners which has the same tag as tag from params.
 * @param {Object} zoneData - Data of all ads.
 * @param {String} tag - Tag of banner.
 * @return {Array}
 */
const getFormats = (zoneData, tag) => {
	if (zoneData) {
		return zoneData.banners.reduce((formats, banner) => {
			if (banner.tag === tag) {
				return [...formats, [...banner.dimensions]];
				// eslint-disable-next-line no-else-return -- Introduced in TP-9489.
			} else {
				return [...formats];
			}
		}, []);
	}

	return [];
};

/**
 * Selects all ad positions on page and tries to
 * fill them with ads according to `tag` param.
 * @param {String} tag
 */
const renderAds = (tag = 'default', formatSwitcher = false) => {
	const adPositions = Array.from(document.querySelectorAll('.Exp-ad'));
	const adsInUse = [];

	adPositions.forEach((ad) => {
		/*  Loop through all ad elements and try to find
            banners in `zones` based on zoneId */
		const zoneId = Number(ad.dataset.zoneid);
		const zoneData = zones.find((zone) => zone.zoneId === zoneId);

		if (zoneData) {
			const unusedBanners = zoneData.banners.filter((banner) => {
				/* Remove already rendered banners from array */
				if (!adsInUse.some((usedBanner) => usedBanner === banner.url)) {
					return banner;
				}
			});

			const filteredData = unusedBanners.filter((banner) => {
				/* If 'default' tag is passed, any unused banner can be displayed */
				if (tag === 'default') {
					return banner;
					// eslint-disable-next-line no-else-return -- Introduced in TP-9489.
				} else {
					return banner.tag === tag ? banner : null;
				}
			});

			ad.classList.remove('ad-empty');

			if (filteredData.length > 0) {
				const banner = randomBanner(filteredData);

				renderBanner(ad, banner);
				adsInUse.push(banner.url);

				if (banner.tag === 'banner' && formatSwitcher) {
					ad.setAttribute('data-format-width', banner.dimensions[0]);
					ad.setAttribute('data-format-height', banner.dimensions[1]);
					renderFormatSwitcher(ad, getFormats(zoneData, 'banner'));
				}
			} else {
				/* No ads for this zone. Render random banner and set inactive. */
				const banner = randomBanner(zoneData.banners);

				renderBanner(ad, banner, false);
			}
		}
	});
};

export { renderBanner, randomBanner, getFormats };
export default renderAds;
